import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import { useSelector } from "react-redux";
import axios from 'axios';
import Swal from 'sweetalert2';
import PayUForm from '../../Utils/PayUForm';
import { toast } from 'react-toastify';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function KUKLKhanepani({ operatorCode }) {
  const currentUser = useSelector((state) => state.data);
  const [counter, setCounter] = useState(false);
  const [detail, setDetail] = useState(false);
  const [type, setType] = useState(1);
  const [payuData, setPayuData] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { Subscriber, counter, Amount, wallet_type } = e.target;
    try {
      let sendData = {
        service: "kuklKhanepani",
        service_provider: operatorCode,
        msisdn: Subscriber.value,
        counter: counter.value,
        amount: Amount?.value,
        type,
        session_id: detail.session_id,
        wallet_type: wallet_type?.value
      };
      if (detail) {
        const response = await axios.post("/recharge/services/pay", sendData);
        const { status, message, hashData, rechage_response: rd } = response.data;
        if (status) {
          if (hashData) {
            const payuData = {
              hash: hashData.hash,
              txnid: hashData.txId,
              amount: hashData.amount,
              firstname: currentUser.name,
              email: currentUser.email,
            };
            setPayuData(payuData);
          }
          else {
            let rechrgeMessage = "<table align='center'><tr><td>Subscriber</td><td>" + rd.subscriber_number + "</td></tr><tr><td>Amount</td><td>" + rd.amount + "</td></tr><tr><td>Receipt</td><td>" + rd.reciept + "</td></tr><tr><td colspan='100%'>" + rd.message + "</td></tr></table>"
            Swal.fire({
              title: 'Recharge Successful!',
              html: rechrgeMessage,
              icon: 'success',
              //confirmButtonText: 'OK'
            });
            setDetail(false);
          }
        }
        else {
          toast(message);
        }
      }
      else {
        const response = await axios.post("/recharge/kuklkhanepani/query", sendData);
        const { status } = response.data;
        if (status) {
          setDetail(response.data);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getData = async () => {
    try {
      const response = await axios.post("/recharge/kuklkhanepani/counter", { service_provider: operatorCode });
      const { status, counters } = response.data;
      if (status) {
        setCounter(counters);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {
        payuData && (
          <PayUForm formData={payuData} autoSubmit={true} />
        )
      }
      <Form onSubmit={handleSubmit}>
        <div className="row">
          <>
            <div class="col-lg-4 col-md-4">
              <label>Type</label>
              <select class="form-control" onChange={(e) => setType(e.target.value)}>
                {
                  ["Customer Code", "Connection Number"].map((data, index) => (
                    <option value={(index + 1)}>{data}</option>
                  ))
                }
              </select>
            </div>
            <div class="col-lg-4 col-md-4">
              <label>{type == 1 ? 'Customer Code' : 'Connection Number'}</label>
              <input type="text" class="form-control" name="Subscriber" required />
            </div>
            {
              counter && (
                <>
                  <div class="col-lg-4 col-md-4">
                    <label>Counters</label>
                    <select class="form-control" name="counter" required>
                      <option value="">--Select--</option>
                      {
                        counter.map(data => (
                          <option value={data.value}>{data.name}</option>
                        ))
                      }
                    </select>
                  </div>
                </>
              )
            }
            {
              detail && (
                <>
                  <div class="col-lg-4 col-md-4">
                    <label>Bill Amount</label>
                    <div>
                      <input type="text" name="Amount" class="form-control" value={(detail.amount)} />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Wallet Type</label>
                    <select class="form-control" name="wallet_type" required>
                      <option value="">--Select--</option>
                      <option value="wallet">Wallet</option>
                      <option value="remitance">Remitance</option>
                      <option value="payu">Online payment(Payu)</option>
                    </select>
                  </div>
                </>
              )
            }
            <div class="col-lg-12 col-md-12">
              <input type="submit" className="search-btn btn btn-primary" value={detail ? "Pay" : "Check Payment"} />
            </div>
          </>
        </div>
      </Form>
    </>
  );
}

export default KUKLKhanepani;
